import { render, staticRenderFns } from "./AprenAiPhone.vue?vue&type=template&id=5b643bda&scoped=true"
import script from "./AprenAiPhone.vue?vue&type=script&lang=js"
export * from "./AprenAiPhone.vue?vue&type=script&lang=js"
import style0 from "./AprenAiPhone.vue?vue&type=style&index=0&id=5b643bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b643bda",
  null
  
)

export default component.exports